import { render, staticRenderFns } from "./iva-compras.vue?vue&type=template&id=1033b802"
import script from "./iva-compras.vue?vue&type=script&lang=js"
export * from "./iva-compras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports